#import "./TorahMelodyDetails.graphql"
#import "./HaftarahMelodyDetails.graphql"
#import "./SentenceGroupMelodyDetails.graphql"
#import "./PronunciationDetails.graphql"
#import "./TagDetails.graphql"
fragment userDetails on UserGrapheneType {
  firstName
  lastName
  email
  username
  torahMelodies {
    melody {
      ...torahMelodyDetails
    }
  }
  haftarahMelodies {
    melody {
      ...haftarahMelodyDetails
    }
  }
  sentenceGroupMelodies {
    melody {
      ...sentenceGroupMelodyDetails
    }
  }
  pronunciations {
    pronunciation {
      ...pronunciationDetails
    }
  }
  tags {
    ...tagDetails
  }
  properties {
    font
    fontSize
    lineHeight
    gender
    theme
    readOnly
    kamatzKatanColor
    shewaNaColor
  }
  groups {
    name
  }
  isStaff
}
